import {
  Button,
  VStack,
  FormControl,
  FormLabel,
  Input,
  Box,
  Text,
  Link,
  useToast,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import PasswordInput from "components/elements/PasswordInput";
import AuthBox from "components/elements/AuthBox";
import { AuthHeading } from "components/layout/AuthLayout";
import { getErrorMessage } from "utils/errorHandler";
import { useAuthenticationActions } from "modules/authentication/mutations/authentication-actions";

export function Login() {
  const toast = useToast();
  const { signIn } = useAuthenticationActions();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const login = async (event: React.FormEvent<HTMLFormElement>) => {
    try {
      event.preventDefault();
      await signIn.mutateAsync({ email, password });
    } catch (err) {
      toast({
        title: "Login Failed",
        description: getErrorMessage(err),
        status: "error",
      });
    }
  };

  useEffect(() => {
    window.analytics.page("Login");
  }, []);

  return (
    <AuthBox>
      <AuthHeading title="Account Login" />
      <Box>
        <form onSubmit={login} noValidate>
          <FormControl mt="16px">
            <FormLabel variant="onboarding">Email Address</FormLabel>
            <Input
              type="email"
              data-cy="email"
              placeholder="john@company.com"
              value={email}
              onChange={ev => setEmail(ev.target.value)}
              variant="primary"
            />
          </FormControl>
          <FormControl mt="16px">
            <FormLabel variant="onboarding">Password</FormLabel>
            <PasswordInput value={password} onChange={setPassword} />
          </FormControl>
          <VStack>
            <Button
              isLoading={signIn.isPending}
              colorScheme="blue"
              type="submit"
              data-cy="submit"
              mt="24px"
              mb="20px"
              px="36px"
            >
              Log In
            </Button>
            <Text fontSize="16px">
              Forgot your password?{" "}
              <Link href={`/reset`} color="primary">
                Reset Password
              </Link>
            </Text>
          </VStack>
        </form>
      </Box>
    </AuthBox>
  );
}
